import * as types from "../../actions/ActionTypes";

const initialState = { loading: false, data: null, error: null, success: false };

const updateOfferReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_OFFER_START:
            return { ...state, loading: true, error: null, success: false };
        case types.UPDATE_OFFER_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null, success: true };
        case types.UPDATE_OFFER_ERROR:
            return { ...state, loading: false, error: action.payload, success: false };
        case types.UPDATE_OFFER_RESET:
            return initialState;
        default:
            return state;
    }
};

export default updateOfferReducer;
